module.exports = __webpack_public_path__ + "img/an.14bacb42.svg";